var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#EF8422;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_1_",
    className: "st2",
    d: "M37.5,26.2c-2.6-2.5-6.3-3.4-9.7-2.1l-0.6-0.6c-0.9-0.9-2.3-0.9-3.2,0l-0.6,0.7 c-1.4-1.4-2.4-2.5-2.5-4c0.4,0.1,0.8,0.6,1.5,1.3c0.1,0.1,0.1,0,0.1-0.1c-1.1-2.3-0.9-2.7,0.7-2.3c0.1,0,0.1-0.1,0.1-0.1 c-1.4-0.9-1.1-1.3,1.3-1.9c0.1,0,0.1-0.1,0-0.1c-2.4-0.1-2.8-0.5-1.6-1.7c0.1-0.1,0-0.1-0.1-0.1c-1.5,0.7-1.7,0.3-0.9-2.1 c0-0.1-0.1-0.1-0.1-0.1c-1.4,2-1.9,2.2-2.3,0.5c0-0.1-0.1-0.1-0.1,0c-0.1,1.7-0.6,1.7-2.3-0.1c0-0.1-0.1,0-0.1,0 c1.1,2.3,0.9,2.7-0.7,2.3c-0.1,0-0.1,0.1-0.1,0.1c1.4,1,1.1,1.4-1.3,2c-0.1,0-0.1,0.1,0,0.1c2.4,0.1,2.8,0.5,1.6,1.7 c-0.1,0.1,0,0.1,0.1,0.1c1.6-0.7,1.7-0.3,1,2.1c0,0.1,0.1,0.1,0.1,0.1c1-1.5,1.5-2,1.9-1.5c0.2,1.7,1.4,3.1,3,4.7l-0.6,0.7 c-0.9,0.9-0.9,2.3,0,3.3l0.6,0.6c-1.3,3.4-0.4,7.3,2.1,9.8c3.6,3.6,9.4,3.6,13,0C41.1,35.7,41.1,29.8,37.5,26.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ied.a60ef508b6de505a748533f21fb61210.svg";